export type globalPagePayload = {
    pageName: string;
    environment: string;
    page: number;
  };
  
  const UPDATE = 'UPDATE_PAGE';
  export type GlobalPageReducerAction = {
    type: string;
    payload: globalPagePayload;
  };
  
  const initialState = [];
  
  export const globalPageInitializer = (initialValue = initialState) =>
    JSON.parse(localStorage.getItem('globalPage')) || initialValue;
  
  export const globalPageReducer = (state: globalPagePayload[], action: GlobalPageReducerAction) => {
      switch (action.type) {
        case UPDATE:
          const newState = state.find(
            item =>
              item.pageName === action.payload.pageName &&
              item.environment === action.payload.environment
          )
            ? state.map(item => {
                return item.pageName === action.payload.pageName
                  ? {
                      environment: action.payload.environment,
                      page: action.payload.page,
                      pageName: action.payload.pageName
                    }
                  : item;
              })
            : [...state, { ...action.payload }];
          return newState;
    
        default:
          return state;
      }
    };
  
    export const updateGlobalPage = (item: globalPagePayload) => ({
      type: UPDATE,
      payload: item
    });
    